// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const stoutland: PokeData = {
  "id": 508,
  "name": "stoutland",
  "height": 12,
  "weight": 610,
  "base_experience": 225,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "leer",
    "bite",
    "roar",
    "reversal",
    "crunch",
    "helping-hand",
    "odor-sleuth",
    "last-resort",
    "giga-impact",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "retaliate",
    "work-up",
    "play-rough",
    "baby-doll-eyes"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "crunch",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "play-rough",
    "body-slam",
    "growl",
    "headbutt",
    "refresh",
    "purification"
  ],
  "evolution_chain": {
    "id": 260,
    "item": null,
    "species": [
      {
        "name": "lillipup",
        "order": 507,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "herdier",
        "order": 508,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 506,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "stoutland",
        "order": 509,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 507,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 126,
    "speed": 115,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
